import { Component, OnInit } from "@angular/core";

@Component({
    template: `
        <login-modal-component></login-modal-component>
        <app-navigation></app-navigation>
        <!-- <app-inner-header></app-inner-header> -->
        <div class="wrapper"><router-outlet></router-outlet></div>
        <public-footer-component></public-footer-component>
    `
})
export class PublicComponent {
    constructor() {
        window.document.title = "ENL Solutions"
    }

}
